import React from 'react';

import svg from './svg/creator_profile.svg';

export function CreatorProfile(props) {
  return <img src={svg} alt="creator-profile-icon" {...props} />;
}
